<template>
  <v-dialog
    v-model="show"
    :max-width="579"
    @click:outside="$emit('hideModal')"
    @keydown.esc="$emit('hideModal')"
  >
    <v-card v-if="!showConfirmRequestViewModal && show">
      <v-card-text class="text-left pa-0">
        <div class="px-6 pt-4 pb-6">
          <p class="h6 headline pt-0 blue-grey--text text--darken-3 mb-8">
            {{ $t('common.validation_requested') }}
          </p>
          <div class="d-flex mb-6">
            <div v-if="requestedBy" class="d-flex flex-column mr-4">
              <p class="caption blue-grey--text text--darken-1 mb-2">
                {{ $t('rev.validation.requested_by') }}
              </p>
              <ChipAvatar class="me-2 mt-2" small :account="requestedBy" />
            </div>
            <div v-if="requestedOn" class="d-flex flex-column">
              <p class="caption blue-grey--text text--darken-1 mb-4">
                {{ $t('rev.validation.requested_on') }}
              </p>
              <v-chip small outlined>
                <v-icon small left color="grey">
                  mdi-calendar-outline
                </v-icon>
                <p data-private class="label pa-0 ma-0">
                  {{ humanDate(requestedOn) }}
                </p>
              </v-chip>
            </div>
          </div>
          <div v-if="assignee" class="d-flex flex-column">
            <p class="caption blue-grey--text text--darken-1 mb-2">
              {{ $t('common.assignee_one') }}
            </p>
            <ChipAvatar class="me-2 mt-2" small :account="assignee" />
          </div>
        </div>
        <v-divider />
        <div class="d-flex justify-end py-4 px-6">
          <Button
            plain
            class="pr-8"
            color="danger"
            data-testid="reqestViewModal-button-send"
            :text="$t('common.button.cancel_request')"
            @click="onCancelRequest"
          />

          <Button
            color="primary"
            data-testid="reqestViewModal-button-cancel"
            :text="$t('common.button.close')"
            @click="$emit('hideModal')"
          />
        </div>
      </v-card-text>
    </v-card>
    <DeleteConfirmationModal
      :show="showConfirmRequestViewModal"
      :maxWidth="454"
      :title="$t('common.cancel_validation_request')"
      :text="$t('common.are_you_sure_you_want_to_cancel')"
      :cancelText="$t('common.button.close')"
      :confirmText="$t('common.button.yes_cancel')"
      @cancel="showConfirmRequestViewModal = false"
      @delete="handleCancelRequest"
    />
  </v-dialog>
</template>

<script>
import mixin from '@/mixins/mixin'
import { utils } from 'frontend-js-shared'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

import Button from '@/components/UI/Button'
import ChipAvatar from '@/components/ChipAvatar.vue'
import DeleteConfirmationModal from '@/components/Modals/DeleteConfirmationModal.vue'

export default {
  name: 'RequestViewModal',

  mixins: [mixin, trackerMixin],

  components: {
    Button,
    ChipAvatar,
    DeleteConfirmationModal,
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    requestValidation: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      showConfirmRequestViewModal: false,
    }
  },

  methods: {
    humanDate(date) {
      return utils.dates.humanDate(date)
    },

    handleCloseModals() {
      this.showConfirmRequestViewModal = false
      this.$emit('hideModal')
    },

    handleCancelRequest() {
      this.trackValidationRequest({
        action: 'cancelConfirm',
        type: 'buttonClick',
      })
      this.$emit('cancelValidationRequest', {
        status: this.$constants.validationRequestStatus.canceled,
        requestId: this.requestId,
      })
      this.handleCloseModals()
    },
    onCancelRequest() {
      this.trackValidationRequest({
        action: 'cancel',
        type: 'buttonClick',
      })
      this.showConfirmRequestViewModal = true
    },
  },
  computed: {
    requestId() {
      return this.requestValidation?.id
    },

    requestedBy() {
      return this.requestValidation?.createdBy
    },
    requestedOn() {
      return this.requestValidation?.createdAt
    },
    assignee() {
      return this.requestValidation?.assignees[0]
    },
  },
}
</script>
